<template>
  <div>
    <b-modal
      class="modal-view-event-training"
      id="modal-view-event-training"
      hide-footer
      centered
      hide-header
      size="l"
    >
      <div class="view-header p-2 d-flex justify-content-between">
        <div>
          <h5>{{ text }}</h5>
        </div>
        <div>
          <b-button class="button p-0" variant="light" @click="closeModalView">
            <h5><b-icon icon="x"></b-icon></h5>
          </b-button>
        </div>
      </div>
      <div class="content mt-2">
        <div class="detail">
          <div class="content">
            <div class="mt-4 mb-4">
              <div class="detail-info row">
                <div class="info col font-weight-bold">
                  <h5>{{ eventTraining.title }}</h5>
                </div>
              </div>
              <div class="detail-info row justify-content-between d-flex text-muted">
                <div class="info col text-muted">
                  Method
                </div>
                <div class="info col text-right font-weight-bold">
                  {{ methodEvent }}
                </div>
              </div>
              <div class="detail-info row justify-content-between d-flex text-muted">
                <div class="info col text-muted">
                  Budget
                </div>
                <div class="info col text-right font-weight-bold">
                  {{ formattedBudget }}
                </div>
              </div>
              <div class="detail-info row justify-content-between d-flex text-muted">
                <div class="info col text-muted">
                  Start Date
                </div>
                <div class="info col text-right font-weight-bold">
                  {{ formatFullDate(eventTraining.startDate) }}
                </div>
              </div>
              <div class="detail-info row justify-content-between d-flex text-muted">
                <div class="info col text-muted">
                  Due Date
                </div>
                <div class="col text-right font-weight-bold">
                  {{ formatFullDate(eventTraining.endDate) }}
                </div>
              </div>
              <div class="detail-info row justify-content-between d-flex text-muted">
                <div class="info col text-muted">
                  Report
                </div>
                <div class="info col text-right font-weight-bold">
                  <a @click="openLink(eventTraining.report)">{{ eventTraining.report }}</a>
                </div>
              </div>
              <div class="detail-info row justify-content-between d-flex text-muted">
                <div class="info col text-muted">
                  Paid Status
                </div>
                <div class="info col text-right">
                  <h5>
                    <b-badge :variant="badgeVariant">{{ badgePaidStatus }}</b-badge>
                  </h5>
                </div>
              </div>
            </div>
            <div>
              <b-form-textarea
                id="textarea"
                v-model="eventTraining.description"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
                readonly
              ></b-form-textarea>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: () => {}
    },
    eventTraining: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      status: {
        paid: '',
        pending: ''
      }
    }
  },
  computed: {
    formattedBudget() {
      if (this.eventTraining.budget === null) {
        return ''
      }
      const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR'
      })
      return formatter.format(this.eventTraining.budget)
    },
    badgeVariant() {
      if (this.eventTraining.statusBudget === 0) {
        return 'success'
      } else if (this.eventTraining.statusBudget === 1) {
        return 'warning'
      } else {
        return 'secondary'
      }
    },
    badgePaidStatus() {
      if (this.eventTraining.statusBudget === 0) {
        return 'Paid'
      } else if (this.eventTraining.statusBudget === 1) {
        return 'Pending'
      } else {
        return 'None'
      }
    },
    methodEvent() {
      if (this.eventTraining.method === true) {
        return 'Online'
      } else {
        return 'Offline'
      }
    }
  },
  methods: {
    closeModalView() {
      this.$bvModal.hide('modal-view-event-training')
    },
    getDayName(dayIndex) {
      const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
      return days[dayIndex]
    },
    getMonthName(monthIndex) {
      const months = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
      ]
      return months[monthIndex]
    },
    formatFullDate(dateTimeString) {
      if (dateTimeString) {
        const dateObj = new Date(dateTimeString)
        const day = this.getDayName(dateObj.getDay())
        const date = dateObj.getDate()
        const month = this.getMonthName(dateObj.getMonth())
        const year = dateObj.getFullYear()
        const formattedTime = dateObj.toLocaleTimeString('id-ID', {
          hour: '2-digit',
          minute: '2-digit'
        })

        return `${day}, ${date} ${month} ${year} ${formattedTime}`
      } else {
        return 'Invalid Date'
      }
    },
    openLink(link) {
      window.open(`https://${link}`)
    }
  }
}

</script>

<style lang="scss" scoped>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.detail-info{
  padding: 0 17px 0 17px;
  .info{
    padding-top: 7px;
    padding-bottom: 7px;
    vertical-align: baseline;

    a{
      color: blue !important
    }
  }
}

.b-icon.bi{
  color: black;
}
.content{
  font-size: 16px;
}
.view-header{
  border-bottom: 1px solid grey;
}

.button{
  color: white;
  background-color: transparent;
  border: none;
}

.badge {
  display: inline-block;
  padding: 0.5em 0.6em;
  font-size: 70%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
